// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4969449e","160":"d9d15d18","208":"583cc840","293":"db6cecc1","453":"74f2558a","516":"333478c0","519":"5a51ec1d","917":"7f4dee56","946":"0fca4eeb"}[chunkId] + ".chunk.js";
};